import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRequest =
        error.config?.url?.includes('/login') ||
        error.config?.url?.includes('/register');
      if (!isAuthRequest) {
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const siteContactService = {
  getSiteContacts: async () => {
    const response = await api.get('/site-contacts');
    return response.data;
  },
  getSiteContact: async (id) => {
    const response = await api.get(`/site-contacts/${id}`);
    return response.data;
  },
  createSiteContact: async (data) => {
    const response = await api.post('/site-contacts', data);
    return response.data;
  },
  updateSiteContact: async (id, data) => {
    const response = await api.put(`/site-contacts/${id}`, data);
    return response.data;
  },
  deleteSiteContact: async (id) => {
    const response = await api.delete(`/site-contacts/${id}`);
    return response.data;
  },
};
